export const retryConfig = {
  initial: 300,
  maxTime: 3000,
  maxAttempts: 5,
  jitter: true,
};
